import { defineComponent as _defineComponent } from 'vue'
import { SelfUserInfo } from "./GeneralUserView.vue";

type Props = {
  item: SelfUserInfo;
};
type UserInfoHeader = {
  text: string;
  value: keyof SelfUserInfo;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GeneralUserDepartmentTable',
  props: {
    item: null
  },
  setup(__props: any) {



const headers: UserInfoHeader[] = [
  { text: "所属コード", value: "affiliationCode" },
  { text: "所属名", value: "affiliationName" },
  { text: "在籍区分", value: "enrollmentClass" },
  { text: "入社年月日", value: "entryDate" },
  { text: "退社年月日", value: "retirementDate" },
  { text: "給与区分", value: "salaryClass" }
];

return { __sfc: true,headers }
}

})